const riot = require('riot');

riot.tag2('module-note', '<div class="f flex-column s-full overflow-hidden"> <div class="px16 pt12 s-p8" ref="header" data-is="module-note-header" show-arrow-button="{opts.showArrowButton}"></div> <div class="relative s-full"> <div class="absolute trbl0 pl4 pt8 pb40 z0"> <div class="w-full h-full" ref="editor" data-is="atom-editor" project="{project}" mentions="{mentions}" should-show-toc="{true}"></div> </div> <div class="absolute l8 b0 f w-full {&quot;b100&quot; : isShowTemplateButton()}"> <div class="w-full f px16 pt8 pb15 bg-white" ref="toolbar" data-is="atom-editor-toolbar"></div> </div> <div class="absolute trbl0 pl4 pt8 z0 pointer-none" show="{isShowEmptyView()}"> <div class="text-label_dark_deep opacity-50" ref="placeholder" data-is="atom-editor" is-placeholder="{true}"></div> </div> <div class="absolute trbl0 f fh fclm z1 pointer-none" if="{isLoading}"> <div data-is="atom-loading"></div> <div class="mt16" data-is="atom-loading-slow"></div> </div> <div class="w-full bg-white absolute p8 b0 z1" if="{isShowTemplateButton()}"> <div class="bold lh15 px12">テンプレートを選択</div> <div class="f overflow-x-scroll pb8"> <div class="max-width-375 w-full p8" each="{item in templates}" if="{item.data.title.length}"> <button class="w-full f fh flex-fixed button px12 py8 primary transition" onclick="{selectTemplate}" onmouseenter="{onSetPlaceholder}" onmouseleave="{onRemovePlaceholder}"><i class="icon-template mr8 fs20"></i> <div class="lh15 word-break-keep line-clamp-1">{item.data.title}</div> </button> </div> </div> </div> </div> </div>', 'module-note,[data-is="module-note"]{display:block}', '', function(opts) {
    this.on('mount', () => {

      this.refs.editor.on('change', () => {
        this.update();
        if (!this.isSyncing) {
          this.hasUnsavedLocalChanges = true;
          this.debouncedSave();
        }
      });
      this.refs.editor.on('submit', () => {
        this.refs.editor.blur();
      });
      this.refs.editor.on('editorCommand', this.onEditorCommand);
      this.refs.toolbar.on('command', ({command, e}) => {
        if (command === 'note') {
          this.openPopupSuggestionNotes(e);
        }
      });
      this.refs.toolbar.setEditor(this.refs.editor);
      this.refs.header.on('arrowclick', (e) => {
        const offset = e.type === 'left' ? -1 : 1;
        this.trigger('pagination', { offset });
      });
    });
    this.on('unmount', () => {
      if (this.note) {
        this.note.unwatch();
        this.note.removeAllListeners();
      }
      this.debouncedFetchHistories?.cancel();
      if (this.refs.editor) {
        this.refs.editor.off('change', this.debouncedSave);
        this.refs.editor.off('editorCommand', this.onEditorCommand);
      }
    });

    this.setNote = async (note, {autofocus=false}={}) => {
      if (this.note) {
        this.note.unwatch();
        this.note.removeAllListeners();

        this.debouncedSave.cancel();
        this.debouncedFetchHistories.cancel();
      }

      this.note = note;
      this.update({ isLoading: true });
      try {
        await this.note.fetch({cache: false, relation: true});
      }
      catch (e) {
        if (this.note === note) {
          this.update({ isLoading: false });
        }
        throw e;
      }

      if (this.note !== note) {
        return ;
      }

      this.isLoading = false;
      spat.updateMeta();
      this.update();

      this.refs.header.setNote(this.note);
      this.refs.editor.setValue(this.note.data.content);

      this.hasUnsavedLocalChanges = false;

      this.refs.editor.editor.clearHistory();

      if (!this.note.data.title) {
        this.refs.placeholder.setValue(app.data.note.placeholder.empty_view);
        this.refs.editor.setCursorToLast();
        this.refs.editor.focus();
      }

      this.project = await this.note.getProject().fetch();

      document.documentElement.style.setProperty('--project-color', this.project?.getColor() || '#4466ea');

      this.update();

      this.mentions = await this.note.getProject().fetchMentions();
      this.update();

      this.templates = await this.note.getProject().fetchTemplates();
      this.isShowTemplateButton();
      this.update();

      this.note.watch();
      this.note.on('snapshot', async () => {
        if (this.refs.editor) {
          let editor_content = this.refs.editor.getValue();
          let remote_content = this.note.data.content;
          let is_my_update = this.note.data.updated_user_ref?.id === app.auth.currentUser.uid;

          let is_my_active_edit_echo = is_my_update && (this.refs.editor.hasFocus() || this.hasUnsavedLocalChanges);
          if (!is_my_active_edit_echo && editor_content !== remote_content) {
            this.isSyncing = true;
            this.refs.editor.syncValue(remote_content);
            this.isSyncing = false;
          }
        }

        this.debouncedFetchHistories();

        this.update();
      });
    };

    this.save = async () => {
      if(!this.note || !this.refs.editor) return ;

      let content = this.refs.editor.getValue();

      if (this.note.data.content === content) {

        this.hasUnsavedLocalChanges = false;
        return ;
      }

      let title = app.utils.getTitle(content);
      let thumbnail = app.utils.getImage(content);

      try {
        let res = await app.api.child(this.note.path).put({
          title: title,
          content: content,
        });

        if (this.refs.editor?.getValue() === content) {
          this.hasUnsavedLocalChanges = false;
        }
        this.refs.placeholder.setValue(app.data.note.placeholder.empty_view);
        this.refs.header.fetchHistories();
        this.update();
      }
      catch (e) {

        console.error('module-note save failed', e);
      }
    };

    this.debouncedSave = _.debounce(() => {
      this.save();
    }, 256);

    this.debouncedFetchHistories = _.debounce(() => {
      this.refs.header?.fetchHistories();
    }, 500);

    this.openPopupAssignUsers = async () => {
      const $cursor = this.refs.editor.getCursor();
      const cursorPosition = $cursor.getBoundingClientRect();
      let assigned_user_refs = this.note.data.assigned_user_refs;
      let project_users = await this.note.parent.parent.fetchProjectUsers();
      const popup = spat.popup.open('popup-suggestion-users', {
        offsetTop: cursorPosition.bottom,
        offsetLeft: cursorPosition.left -40,
        opts: {
          label: 'アサインユーザーを編集',
          users: project_users,
          selectedUsersIds: assigned_user_refs.map(user => user.id),
        },
      }).on('userselect', async ({user, selectedUsers, checked}) => {
        try {
          await this.note.assign(selectedUsers.map(user => user.id));

          app.utils.openToast(checked ? 'assignedUpdate' : 'unassignedUpdate', {label: user.data.screen_name});
        }
        catch(e) {
          spat.modal.alert('更新に失敗しました');
        }
        this.update();
      }).on('close', () => {
        this.refs.editor.focus();
      });
    };

    this.selectTemplate = async (e) => {
      this.update();

      let content = await app.utils.getTemplateContent(e.item.item);

      this.refs.editor.setValue(content);
      this.refs.editor.focus();
    };

    this.isShowEmptyView = () => {
      if(!this.note || !this.refs.editor) return false;

      let content = this.refs.editor.getValue();

      let { data } = app.utils.parseFrontmatter(content);
      if (data) return false;
      return !app.utils.getTitle(content);
    };

    this.isShowTemplateButton = () => {
      if (!this.note || !this.refs.editor) return false;

      if (!this.templates.length) return false;

      let content = this.refs.editor.getValue();
      return content.trim() === "" || content.trim() === "#";
    };

    this.onEditorCommand = async ({command, editor, data, completion, tag}) => {
      if (!this.note) return;

      if (command === 'assign') {
        this.openPopupAssignUsers();
      }

      if (command === 'link') {
        this.tags["atom-link"].onOpenLinkModal();
      }

      if (command === 'note') {
        this.openPopupSuggestionNotes();
      }

      if (command === 'table') {
        app.utils.openCursorPopupTable(this.refs.editor);
      }

      if (command === 'templates') {
        this.openPopupTemplates();
      }
    };

    this.openPopupSuggestionNotes = async (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      const $cursor = this.refs.editor.getCursor();
      const cursorPosition = $cursor.getBoundingClientRect();
      const popup = spat.popup.open('popup-suggestion-notes', {
        offsetTop: cursorPosition.bottom,
        offsetLeft: cursorPosition.left -40,
        closeTarget: e ? e.currentTarget : '',
      });
      const selected_notes = await popup.waitClose();
      if (selected_notes?.length) {
        const promises = selected_notes.map(async (selected_note) => {
          let title = selected_note.data.title;

          if (this.note.getProject().id !== selected_note.getProject().id) {
            const project = await selected_note.getProject().fetch();
            title += ` - ${project.data.name}`;
          }

          let list_symbol = selected_notes.length > 1 ? '- ' : '';
          const formatted_title = list_symbol + app.utils.getInsertLinkToTitle({
            title,
            url: `/${selected_note.path}`,
          });

          return formatted_title;
        });

        const titles = await Promise.all(promises);
        const text = titles.join('\n');

        this.refs.editor.insertTextAtCursor(text);

        this.refs.editor.focus();
      }
    };

    this.openPopupTemplates = async (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      const $cursor = this.refs.editor.getCursor();
      const cursorPosition = $cursor.getBoundingClientRect();
      const popup = spat.popup.open('popup-templates', {
        offsetTop: cursorPosition.bottom,
        offsetLeft: cursorPosition.left -40,
        closeTarget: e ? e.currentTarget : '',
        opts: {
          templates: this.templates,
        }
      });
      await popup.waitClose();
      if (popup.value) {
        let content = app.utils.getTemplateContent(popup.value);
        this.refs.editor.setValue(content);
      }
    };

    this.onSetPlaceholder = (e) => {
      let content = app.utils.getTemplateContent(e.item.item);
      this.refs.placeholder.setValue(content);
      this.update();
    };

    this.onRemovePlaceholder = () => {
      this.refs.placeholder.setValue(app.data.note.placeholder.empty_view);
    };
});